<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-param-set`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.5195 7.00195C11.0718 7.00195 11.5195 6.55424 11.5195 6.00195V5.22168H13.9199C14.2872 5.22168 14.585 4.92391 14.585 4.55664C14.5849 4.18943 14.2871 3.8916 13.9199 3.8916H11.5195V3.11035C11.5191 2.55842 11.0716 2.11035 10.5195 2.11035C9.9675 2.11035 9.51994 2.55842 9.51953 3.11035V6.00195C9.51953 6.55424 9.96725 7.00195 10.5195 7.00195ZM8.0791 5.22168C8.44637 5.22168 8.74414 4.92391 8.74414 4.55664C8.74406 4.18944 8.44632 3.8916 8.0791 3.8916H2.0791C1.71207 3.89182 1.41414 4.18958 1.41406 4.55664C1.41406 4.92377 1.71202 5.22146 2.0791 5.22168H8.0791ZM5.48242 13.8828C6.03471 13.8828 6.48242 13.4351 6.48242 12.8828V9.99121C6.48213 9.43918 6.03452 8.99121 5.48242 8.99121C4.93032 8.99121 4.48272 9.43918 4.48242 9.99121V10.7725H2.0791C1.71203 10.7727 1.41406 11.0704 1.41406 11.4375C1.4141 11.8046 1.71205 12.1023 2.0791 12.1025H4.48242V12.8828C4.48242 13.4351 4.93014 13.8828 5.48242 13.8828ZM13.9199 12.1025C14.2872 12.1025 14.5849 11.8047 14.585 11.4375C14.585 11.0702 14.2872 10.7725 13.9199 10.7725H7.91992C7.55278 10.7726 7.25488 11.0703 7.25488 11.4375C7.25492 11.8046 7.5528 12.1024 7.91992 12.1025H13.9199Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineParamSet',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
